import { CaseOrigin } from '../../../../types/LegalCase';

interface CaseOriginBadgeProps {
    origin?: string;
    originFormatted?: string;
}

// Selo "Origem: Cobrança" do caso aberto pela cobrança (Task 16 / AF-3694), na grid e no detalhe.
// Caso manual não leva selo: é o normal, e marcá-lo só poluiria a lista. Mesma paleta do selo
// "Cobrança" do título na pretensão — os dois dizem que o dado veio de lá.
const CaseOriginBadge = ({ origin, originFormatted }: CaseOriginBadgeProps) => {
    if (origin !== CaseOrigin.COLLECTION) return null;
    return (
        <span
            className="inline-flex px-2 py-0.5 rounded-full text-[10px] font-medium bg-blue-100 dark:bg-blue-900 text-blue-700 dark:text-blue-300 whitespace-nowrap"
            title="Caso aberto sozinho quando a cobrança enviou o título para o jurídico"
        >
            Origem: {originFormatted || 'Cobrança'}
        </span>
    );
};

export default CaseOriginBadge;
